/**
 * The lot of an inspection as its work object counts it. When the item has
 * several pieces each, the inspection counts pieces and its sample size comes
 * from them, so they follow in brackets: "1000 (2000 PCE)".
 */
export const formatLotQuantity = ({
  quantity,
  partialQuantity,
  quantityUOM,
}) => {
  const lot = partialQuantity ?? quantity;
  if (lot == null) return '-';
  if (quantity == null || quantity === lot) return String(lot);

  return `${lot} (${quantity}${quantityUOM ? ` ${quantityUOM}` : ''})`;
};
